export default class Auth {
  loggingIn = false;

  loggedIn = false;

  username = '';

  token = '';

  error = '';

  constructor(auth = {
    loggingIn: false,
    loggedIn: false,
    username: '',
    token: '',
    error: '',
  }) {
    this.loggingIn = auth.loggingIn;
    this.loggedIn = auth.loggedIn;
    this.username = auth.username;
    this.token = auth.token;
    this.error = auth.error;
  }

  setLoggingIn(loggingIn) {
    this.loggingIn = loggingIn;
    return this;
  }

  setLoggedIn(loggedIn) {
    this.loggedIn = loggedIn;
    return this;
  }

  setUsername(username) {
    this.username = username;
    return this;
  }

  setToken(token) {
    this.token = token;
    return this;
  }

  setError(error) {
    this.error = error;
    return this;
  }

  isAuthenticated() {
    return this.loggedIn;
  }
}
